import React, { forwardRef, useId } from "react";
import "./index.css";

const Input = forwardRef(({ label, icon, style, className, value, onChange, placeholder, "data-testid": dataTestId, autocomplete, onKeyDown, onKeyPress, onKeyUp, preventExponent = true, padToLength, ...otherProps }, ref) => {
  const { type = "text" } = otherProps;
  
  // Handler for clear button
  const handleClear = (e) => {
    if (onChange) {
      onChange({
        ...e,
        target: { ...e.target, value: "" },
      });
    }
  };

  // Enhanced onChange handler with padding support
  const handleChange = (e) => {
    let newValue = e.target.value;
    if(parseInt(newValue, 10).toString().length > 6 && type === "number") {
      return; // Prevent input if it exceeds 6 digits for number type
    }

    // Apply padding if specified and value is not empty
    if (padToLength && newValue && !isNaN(newValue)) {
      newValue = (parseInt(newValue, 10)).toString().padStart(padToLength, '0');
    }

    // Create modified event with padded value
    const modifiedEvent = {
      ...e,
      target: { ...e.target, value: newValue }
    };

    if (onChange) {
      onChange(modifiedEvent);
    }
  };

  // Enhanced keyDown handler to prevent 'e', 'E', '+', '-' in number inputs
  const handleKeyDown = (e) => {
    if (type === "number" && preventExponent) {
      // Prevent 'e', 'E', '+', '-' for number inputs
      if (['e', '+', '-'].includes(e.key.toLowerCase())) {
        e.preventDefault();
        return;
      }
    }

    if (onKeyDown) {
      onKeyDown(e);
    }
  };
  const generatedId = useId();
  const inputId = `inputField-${generatedId}`;

  return (
    <div className={`input-wrapper ${className || ""}`.trim()}>
      <div style={style} className="inputContainer">
        <input
          className={`inputField${icon ? ' inputField--withIcon' : ''}`}
          data-testid={dataTestId || "input-field"}
          ref={ref}
          required="required"
          id={inputId}
          placeholder={placeholder || label}
          type={type}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          autoComplete={autocomplete ? "on" : "off"}
          {...otherProps}
        />
        <label className="label" htmlFor={inputId}>
          {label}
        </label>
        {icon && <span className="icon">{icon}</span>}
        {value?.toString().length > 0 && (
          <button type="button" className={`clearButton${type === "number" ? " clearButton--number" : ""}`} aria-label="Clear input" onClick={handleClear}>
            &#10005;
          </button>
        )}
      </div>
    </div>
  );
});
export default Input;
